module.exports = __webpack_public_path__ + "img/campus-mediathek.efe197fc.svg";